import { useState } from 'react'
import { GridSelectionModel } from '../utils/types'

export default function useDefaultSelectionModel(
    initialSelection: GridSelectionModel = [],
) {
    const [selectionModel, setSelectionModel] =
        useState<GridSelectionModel>(initialSelection)

    return [selectionModel, setSelectionModel] as const
}
